var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10L12.4711 15.7991C12.4093 15.8628 12.3358 15.9133 12.255 15.9478C12.1742 15.9823 12.0875 16 12 16C11.9125 16 11.8258 15.9823 11.745 15.9478C11.6642 15.9133 11.5907 15.8628 11.5289 15.7991L6 10",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDEwTDEyLjQ3MTEgMTUuNzk5MUMxMi40MDkzIDE1Ljg2MjggMTIuMzM1OCAxNS45MTMzIDEyLjI1NSAxNS45NDc4QzEyLjE3NDIgMTUuOTgyMyAxMi4wODc1IDE2IDEyIDE2QzExLjkxMjUgMTYgMTEuODI1OCAxNS45ODIzIDExLjc0NSAxNS45NDc4QzExLjY2NDIgMTUuOTEzMyAxMS41OTA3IDE1Ljg2MjggMTEuNTI4OSAxNS43OTkxTDYgMTAiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";